<!--  -->
<template>
  <div>
    <div class>
      <Steps :active="5" align-center>
        <Step :title="$t('course.csbase')" @click.native="on_click('csbase')" />
        <Step :title="$t('course.cscondition')" @click.native="on_click('cscondition')" />
        <Step :title="$t('course.csprice')" @click.native="on_click('csprice')" />
        <Step :title="$t('course.csrpt')" @click.native="on_click('csrpt')" />
        <Step :title="$t('course.csinvest')" @click.native="on_click('csinvest')" />
        <Step :title="$t('course.csability')" />
      </Steps>
    </div>
    <br/>
    <div class='divMessage'style=" word-wrap:break-word; word-break:break-all;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
    <br/>
    <el-card class="aui-card--fill"
                shadow="never">
      <el-row>
        <el-col :span="2"><div class="grid-content" /></el-col>
        <el-col :span="20">
          <el-button  class="el-back" type="info" disabled >+添加对应能力项</el-button>
          <el-table
            :data="tableData"
            border
            style="width: 80%"
          >
            <el-table-column
              prop="name"
              label="职位"
              width="180"
              align="center"
            />
            <el-table-column
              prop="address"
              label="能力项"
              align="center"
            />
          </el-table>
        </el-col>
      </el-row>

    </el-card>
    <div>
       <el-row  style="float:right; margin-bottom: 60px;">
          <el-col :span="16"><div class="grid-content" /></el-col>
          <el-button v-if="checkSaveNextRole()"
                     @click="sendMsg"  type="primary">{{ $t("course.saveAndRelease") }}</el-button>
          <el-button v-if="checkSaveCloseRole()"
                     @click="save"  type="primary">{{ $t("course.save") }}</el-button>
          <ZElButton @click="cancel" >{{ $t("course.cancel") }}</ZElButton>
       </el-row>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
import ZElButton from '../../common/button/index'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: { Steps, Step, ZElButton },
  props: ['message', 'issaveall', 'courseid'],
  inject: ['toTop'],
  data () {
    let _this = this
    // 这里存放数据
    return {
      // message: '',
      dataIsSaveAll: '',
      courseId: '',
      tableData:[],
      // tableData: [{
      //   name: '客户关系经理',
      //   address: '客户导向，案例分析能力'
      // }, {
      //   name: 'MINI市场经理',
      //   address: '客户导向'
      // }],
      allteamcatalog: _this.enums['catalogidList2'],
      dataForm: {
        courseId: '',
        courseStatus: '20'
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    issaveall: function (newVal, oldVal) {
      this.dataIsSaveAll = newVal // newVal即是chartData
    } },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    console.log('created')
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    var courseId = this.$route.query.courseId
    if (courseId === undefined) {
      this.courseId = courseId
      this.dataForm.courseId = courseId
    }
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    console.log('activated')
  },
  // 方法集合
  methods: {
    sendMsg () {
      //
      console.log(this.dataIsSaveAll)
      console.log(this.issaveall)
      this.dataForm.courseId = this.courseid
      if (this.dataIsSaveAll || this.issaveall) {
        this.$request.put(`/learning/courseinfo/csabilitySave`,
          this.dataForm
        ).then((res, total, code, data) => {
          if (data.code === 13000000) {
            this.$message({
              message: this.$t(data.msg),
              type: 'error',
              duration: 2000
            })
          } else if (data.code === 1) {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500
            })
          }
          // this.$emit('onShowModer', 'courseend')
          this.tabRemove()
          console.log('this.dataForm.courseid')
          console.log(this.dataForm.courseId)
          this.$router.push({
            name: 'learning-course-courseend', query: { courseId: this.dataForm.courseId }
          })
        }).catch(e => {
          console.log(e)
        })
      } else {
        this.$message({
          type: 'error',
          message: '其中有未保存页,不能发布课程'
        })
      }
    },
    on_click (e) {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('onShowModer', e)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    // 保存当前页面数据
    save () {
      this.dataForm.courseId = this.courseid
      this.$request.put(`/learning/courseinfo/courseSave`,
        this.dataForm
      ).then((res, total, code, data) => {
        if (data.code === 13000000) {
          this.$message({
            message: this.$t(data.msg),
            type: 'error',
            duration: 2000
          })
        } else if (data.code === 1) {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          this.tabRemove()
          this.$router.push({
            name: 'learning-course-courseinfo'
          })
        }
      }).catch(e => {
        console.log(e)
      })
    },
    init (onCourseId) {
      // 点击圆圈初始化
    },
    // 取消按钮
    cancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabRemove()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 保存下一步
    checkSaveNextRole () {
      if (!this.$hasPermission('learning:courseinfo:csabilitySave')) {
        return false
      }
      if (this.$hasPermission('learning:courseinfo:release')) {
        return true
      }
      for (var val of this.allteamcatalog) {
        if (this.$hasPermission('TEAM:'+val.code)) {
          return true
        }
      }
      return false
    },
    // 保存下一步
    checkSaveCloseRole () {
      if (this.$hasPermission('learning:courseinfo:csabilitySave')) {
        return true
      }
      return false
    }
  }
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.grid-content {
    border-radius: 4px;
    min-height: 20px;
  }
.el-back:focus {
    background: #c8c9cc !important;
    border: 1px #c8c9cc solid !important;
}
</style>
